import styled from "styled-components";

const SectionBody = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 30px;
    flex-direction: column;
`;

export default SectionBody;
